const RUANG_LAB_KOMPUTER_ALSUT = 1;
const LOKASI_ANGGREK = 3;
const LOKASI_BEKASI = 5;
const RUANG_LAB_FOODTECH_ALSUT = 6;

export {
  RUANG_LAB_KOMPUTER_ALSUT,
  LOKASI_ANGGREK,
  LOKASI_BEKASI,
  RUANG_LAB_FOODTECH_ALSUT,
};
